export default __webpack_public_path__ + "0b6ec3fc6620fa32b5d3212f10b1d2f5.png";